import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';

export function* GetReciptCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.GET_RECEIPT_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SavePurchaseRecipt(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.RECEIPT.SAVE_PURCHASE_RECEIPT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* UploadAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.RECEIPT.UPLOAD_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetReciptList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.GET_RECEIPT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportToPdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.EXPORT_TO_PDF, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportToXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.EXPORT_TO_XLS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetReciptByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.GET_RECEIPT_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetReciptAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.GET_RECEIPT_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetPurchaseHistoryList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECEIPT.GET_PURCHASE_HISTORY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}